import React from 'react'
import HeaderScout from '../components/Header/ScoutLoggedinHeader/HeaderScout'

const ScoutLayout = ({ children }) => {
    return (
        <div className='scout-layout'>
            <HeaderScout />
            <div className="scout-main">
                <div className="scout-content">{children}</div>
            </div>
        </div>
    )
}

export default ScoutLayout